import {Calendar} from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import './magnific-popup.min.js';

document.addEventListener( 'DOMContentLoaded', function() {

    var calendarEl = document.getElementById( 'calendar' );

    var catExclusions = [];

    function eventClick( info ) {
        info.jsEvent.preventDefault();

        if ( info.el.classList.contains( 'fc-event_private' ) ||
             info.el.classList.contains( 'fc-event_unconfirmed' ) ) {

            return false;
        }

        if ( info.event.url ) {
            $.magnificPopup.open( {
                items: {
                    type: 'ajax',
                    src: info.event.url,
                },
                ajax: {
                    settings: {
                        data: 'request=1',
                    },
                },
            } );
        }
        return false;
    }

    var calendar = new Calendar( calendarEl, {
        plugins: [ dayGridPlugin, listPlugin ],
        headerToolbar: {
            left: 'prev,today,next',
            center: 'title',
            right: 'dayGridMonth dayGridWeek listMonth',
        },
        eventClick: eventClick,
        eventSources: [
            {
                id: 'main-event-src',
                url: '/rec-event-data',
                extraParams: function() {
                    return {
                        excludes: catExclusions,
                    };
                },
                failure: function() {
                    window.alert( 'There was an error while fetching events.' );
                },
            },
        ],
        contentHeight: 'auto',
        buttonText: {
            month: 'Month',
            list: 'List'
        },
        initialView: 'dayGridMonth',
    } );

    calendar.render();

    var event_src = calendar.getEventSourceById( 'main-event-src' );
    var inputs = document.querySelectorAll( '#event-filter-group .cat-filter input' );

    function refreshFilterEvents() {
        catExclusions = [];

        if ( 0 < inputs.length ) {
            var filterNumber;

            for ( var i = 0; i < inputs.length; i++ ) {
                filterNumber = parseInt( inputs[i].dataset.catFilter );

                if ( !inputs[i].checked ) {
                    catExclusions.push( filterNumber );
                }
            }
        }
        event_src.refetch();
    }

    for ( var i = 0; i < inputs.length; i++ ) {
        inputs[i].addEventListener( 'click', refreshFilterEvents, { passive: true } );
    }

    function maybeChangeView() {

        if ( window.innerWidth < 1000 ) {
            calendar.changeView('listMonth');
        } else {
            calendar.changeView('dayGridMonth');
        }
    }

    maybeChangeView();
    window.addEventListener( 'resize', maybeChangeView, { passive: true } );

} );
